module.exports = __webpack_public_path__ + "img/Porto Apartment - 30 of 85.cc77bbe4.jpeg";